<p-toast></p-toast>
<div class="peer-signup-container">
  <!-- ═══════════════════════════════════════════════════
       INTRO PAGE
  ════════════════════════════════════════════════════ -->
  <div *ngIf="showIntro" class="intro-page">

    <div class="intro-hero-wrap">
      <!-- HERO -->
      <div class="hero-section">
        <div class="hero-copy-center">
          <h1>Create Your </h1>
          <h1><span class="highlight-yellow">Grad Pilots</span> Profile</h1>
          <p class="hero-description">
            You've been through the grind. Your experience test scores, visa process, campus life is
            gold for students who come after you. Build your peer profile in 5 minutes.
          </p>
          <button pButton type="button" class="hero-cta" (click)="startSignup()">
            Start Building My Profile
          </button>
        </div>

        <div class="hero-visual-full">
          <div class="bubble bubble-1"><img src="assets/images/Group-37.png" alt="" /></div>
          <div class="bubble bubble-2"><img src="assets/images/Group-36.png" alt="" /></div>
          <div class="bubble bubble-3"><img src="assets/images/Group-39.png" alt="" /></div>
          <div class="bubble bubble-4"><img src="assets/images/Group-38.png" alt="" /></div>
          <div class="laptop-frame">
            <img src="assets/images/peer-intro.png" alt="Peer Intro" class="laptop-img" />
          </div>
        </div>
      </div>

      <!-- FEATURE PANEL -->
      <div class="feature-panel">
        <div class="feature-grid">
          <div class="feature-card">
            <div class="feature-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-svg">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
            </div>
            <h3>Get Discovered</h3>
            <p>Students applying to your university will find and reach out to you.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-svg">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <h3>Build Network</h3>
            <p>Connect with a global community of students studying abroad.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-svg">
                <path
                  d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z">
                </path>
              </svg>
            </div>
            <h3>Pay It Forward</h3>
            <p>Be the mentor you wish you had when you started your journey.</p>
          </div>
        </div>
        <p class="feature-note">
          <i class="pi pi-lock"></i>
          Your contact details are never public. You control who can reach you.
        </p>
      </div>
    </div>

    <!-- FAQ -->
    <div class="faq_001">
      <div class="faq-section">
        <h2>Questions about our Peer Program?</h2>
        <p class="faq-subtitle">We have answers!</p>
        <p-accordion [multiple]="false" class="faq-accordion" expandIcon="pi pi-chevron-down"
          collapseIcon="pi pi-chevron-up">
          <p-accordionTab *ngFor="let faq of faqs" [header]="faq.question">
            <p>{{ faq.answer }}</p>
          </p-accordionTab>
        </p-accordion>
      </div>
    </div>

  </div>

  <!-- ═══════════════════════════════════════════════════
       WIZARD LAYOUT
  ════════════════════════════════════════════════════ -->
  <div *ngIf="!showIntro" class="wizard-layout">

    <!-- SIDEBAR -->
    <aside class="wizard-sidebar">
      <div class="sidebar-mobile-header">
        <div class="header-left">
          <div class="sidebar-count-circle">
            <span class="count">{{ currentStep }}/{{ stepTitles.length }}</span>
            <span class="label">steps</span>
          </div>
        </div>
        <div class="header-right">
          <h2 class="mobile-step-title">{{ stepTitles[currentStep - 1] }}</h2>
          <p class="mobile-next-step" *ngIf="currentStep < stepTitles.length">
            Next &rarr; <span class="highlight">{{ stepTitles[currentStep] }}</span>
          </p>
        </div>
      </div>

      <div class="mobile-progress-bar">
        <div class="progress-segment" *ngFor="let title of stepTitles; let i = index" [class.active]="currentStep > i"
          [class.current]="currentStep === i + 1">
        </div>
      </div>

      <div class="sidebar-top desktop-only">
        <div class="sidebar-count-circle">
          <span class="count">{{ currentStep }}/{{ stepTitles.length }}</span>
          <span class="label">steps</span>
        </div>
        <p class="sidebar-status-label">IN PROGRESS</p>
      </div>

      <div class="sidebar-steps desktop-only">
        <button type="button" class="sidebar-step" *ngFor="let title of stepTitles; let i = index"
          [class.active]="currentStep === i + 1" [class.completed]="currentStep > i + 1" (click)="goToStep(i + 1)"
          [disabled]="currentStep < i + 1 && !isStepValid(currentStep)">
          <span class="step-circle">
            <i *ngIf="currentStep > i + 1" class="pi pi-check"></i>
            <span *ngIf="currentStep <= i + 1">{{ i + 1 }}</span>
          </span>
          <span class="step-info">
            <span class="step-name">{{ title }}</span>
            <span class="step-caption">{{ stepSubtitles[i] }}</span>
          </span>
        </button>
      </div>

      <!-- <div class="sidebar-footer desktop-only">
        <p>Your progress is auto-saved</p>
        <p class="sub">You can return anytime to continue</p>
      </div> -->
    </aside>

    <!-- MAIN CONTENT -->
    <main class="wizard-main">
      <div class="wizard-header desktop-only">
        <h1>{{ stepTitles[currentStep - 1] }}</h1>
        <p class="wizard-description">{{ stepSubtitles[currentStep - 1] }}</p>
      </div>

      <div class="wizard-form">
        <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
          <div class="step-content">
            <ng-container [ngSwitch]="currentStep">

              <!-- ════════════════════════════════
                   STEP 1 — ABOUT YOU
              ═════════════════════════════════ -->
              <div *ngSwitchCase="1">
                <div class="section-subheader">PERSONAL INFORMATION</div>

                <div class="form-grid">
                  <div class="form-group">
                    <label for="firstName" class="required">First name</label>
                    <input id="firstName" formControlName="FirstName" pInputText class="form-control"
                      [class.invalid]="submitted && f['FirstName'].invalid" placeholder="e.g. Amy" />
                    <ng-container *ngIf="submitted && f['FirstName'].invalid">
                      <div class="field-error" *ngIf="f['FirstName'].errors?.['required']">First name is required.</div>
                      <div class="field-error" *ngIf="f['FirstName'].errors?.['minlength']">At least 2 characters
                        required.</div>
                      <div class="field-error" *ngIf="f['FirstName'].errors?.['pattern']">Only letters, spaces, hyphens
                        and apostrophes allowed.</div>
                    </ng-container>
                  </div>

                  <div class="form-group">
                    <label for="lastName" class="required">Last name</label>
                    <input id="lastName" formControlName="LastName" pInputText class="form-control"
                      [class.invalid]="submitted && f['LastName'].invalid" placeholder="e.g. Patel" />
                    <ng-container *ngIf="submitted && f['LastName'].invalid">
                      <div class="field-error" *ngIf="f['LastName'].errors?.['required']">Last name is required.</div>
                      <div class="field-error" *ngIf="f['LastName'].errors?.['minlength']">At least 2 characters
                        required.</div>
                      <div class="field-error" *ngIf="f['LastName'].errors?.['pattern']">Only letters, spaces, hyphens
                        and apostrophes allowed.</div>
                    </ng-container>
                  </div>
                </div>

                <div class="form-group full-width">
                  <label for="email" class="required">Email address</label>
                  <input id="email" formControlName="Email" pInputText class="form-control"
                    [class.invalid]="submitted && f['Email'].invalid" placeholder="e.g. soji&#64;gmail.com" />
                  <ng-container *ngIf="submitted && f['Email'].invalid">
                    <div class="field-error" *ngIf="f['Email'].errors?.['required']">Email is required.</div>
                    <div class="field-error" *ngIf="f['Email'].errors?.['email']">Please enter a valid email address
                      (e.g. name&#64;domain.com).</div>
                    <div class="field-error" *ngIf="f['Email'].errors?.['duplicate']">This email is already registered.
                      Please use another email.</div>
                  </ng-container>
                </div>

                <div class="form-grid">
                  <div class="form-group">
                    <label for="whatsapp">WhatsApp</label>
                    <input id="whatsapp" formControlName="WhatsAppNumber" pInputText class="form-control"
                      [class.invalid]="f['WhatsAppNumber'].invalid && f['WhatsAppNumber'].touched"
                      placeholder="e.g. 8976543210" />
                    <div *ngIf="f['WhatsAppNumber'].invalid && f['WhatsAppNumber'].touched" class="field-error">
                      Enter digits only, 7–15 characters (e.g. 9876543210).
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="linkedin">LinkedIn profile</label>
                    <input id="linkedin" formControlName="LinkedInUrl" pInputText class="form-control"
                      [class.invalid]="f['LinkedInUrl'].invalid && f['LinkedInUrl'].touched"
                      placeholder="e.g. linkedin.com/in/amypatel" />
                    <div *ngIf="f['LinkedInUrl'].invalid && f['LinkedInUrl'].touched" class="field-error">
                      Enter a valid LinkedIn URL (e.g. linkedin.com/in/yourname).
                    </div>
                  </div>
                </div>

                <div class="section-subheader">LOCATION</div>
                <div class="form-grid">
                  <div class="form-group">
                    <label for="currentCity" class="required">Current city</label>
                    <input id="currentCity" formControlName="CurrentCity" pInputText class="form-control"
                      [class.invalid]="submitted && f['CurrentCity'].invalid" placeholder="e.g. Bangalore" />
                    <ng-container *ngIf="submitted && f['CurrentCity'].invalid">
                      <div class="field-error"
                        *ngIf="f['CurrentCity'].errors?.['required'] || f['CurrentCity'].errors?.['minlength']">
                        Current city is required (min 2 chars).
                      </div>
                    </ng-container>
                  </div>

                  <div class="form-group">
                    <label for="currentCountry" class="required">Current country</label>
                    <input id="currentCountry" formControlName="CurrentCountry" pInputText class="form-control"
                      [class.invalid]="submitted && f['CurrentCountry'].invalid" placeholder="e.g. India" />
                    <ng-container *ngIf="submitted && f['CurrentCountry'].invalid">
                      <div class="field-error"
                        *ngIf="f['CurrentCountry'].errors?.['required'] || f['CurrentCountry'].errors?.['minlength']">
                        Current country is required (min 2 chars).
                      </div>
                    </ng-container>
                  </div>

                  <div class="form-group">
                    <label for="originCity" class="required">Origin city</label>
                    <input id="originCity" formControlName="OriginCity" pInputText class="form-control"
                      [class.invalid]="submitted && f['OriginCity'].invalid" placeholder="e.g. Chennai" />
                    <ng-container *ngIf="submitted && f['OriginCity'].invalid">
                      <div class="field-error"
                        *ngIf="f['OriginCity'].errors?.['required'] || f['OriginCity'].errors?.['minlength']">
                        Origin city is required (min 2 chars).
                      </div>
                    </ng-container>
                  </div>

                  <div class="form-group">
                    <label for="originCountry" class="required">Origin country</label>
                    <input id="originCountry" formControlName="OriginCountry" pInputText class="form-control"
                      [class.invalid]="submitted && f['OriginCountry'].invalid" placeholder="e.g. India" />
                    <ng-container *ngIf="submitted && f['OriginCountry'].invalid">
                      <div class="field-error"
                        *ngIf="f['OriginCountry'].errors?.['required'] || f['OriginCountry'].errors?.['minlength']">
                        Origin country is required (min 2 chars).
                      </div>
                    </ng-container>
                  </div>
                </div>

                <div class="form-group full-width">
                  <label class="required">Gender</label>
                  <div class="radio-grid">
                    <div class="radio-option" *ngFor="let option of genderOptions; let i = index">
                      <p-radioButton name="Gender" [value]="option.value" formControlName="Gender"
                        [inputId]="'gender_' + i">
                      </p-radioButton>
                      <label [for]="'gender_' + i">{{ option.label }}</label>
                    </div>
                  </div>
                  <div *ngIf="submitted && f['Gender'].invalid" class="field-error">Gender is required.</div>
                </div>
              </div>

              <!-- ════════════════════════════════
                   STEP 2 — EDUCATION
              ═════════════════════════════════ -->
              <div *ngSwitchCase="2">

                <!-- Study Level -->
                <div class="form-group full-width">
                  <label class="required">Highest Study Level</label>
                  <p class="section-instruction">Choose your Highest Education Level</p>
                  <div class="radio-grid">
                    <div class="radio-option" *ngFor="let option of studyLevels; let idx = index">
                      <p-radioButton name="StudyLevel" [inputId]="'studyLevel_' + idx" formControlName="StudyLevel"
                        [value]="option.value">
                      </p-radioButton>
                      <label [for]="'studyLevel_' + idx">{{ option.label }}</label>
                    </div>
                  </div>
                  <div *ngIf="submitted && f['StudyLevel'].invalid" class="field-error">Study level is required.</div>
                </div>

                <!-- School Background -->
                <div class="section-header">SCHOOL BACKGROUND</div>
                <div class="form-grid grid-2-to-4">
                  <div class="form-group">
                    <label for="schoolName" class="required">School Name</label>
                    <input id="schoolName" formControlName="SchoolName" pInputText class="form-control"
                      [class.invalid]="submitted && f['SchoolName'].invalid" placeholder="e.g. St. Mary's" />
                    <div *ngIf="submitted && f['SchoolName'].invalid" class="field-error">School name is required (min 2
                      chars).</div>
                  </div>

                  <div class="form-group">
                    <label for="schoolBoard" class="required">Board</label>
                    <input id="schoolBoard" formControlName="SchoolBoard" pInputText class="form-control"
                      [class.invalid]="submitted && f['SchoolBoard'].invalid" placeholder="e.g. CBSE" />
                    <div *ngIf="submitted && f['SchoolBoard'].invalid" class="field-error">Board is required (e.g. CBSE,
                      ICSE, IB).</div>
                  </div>

                  <div class="form-group">
                    <label for="classX">Class X result</label>
                    <input id="classX" formControlName="ClassXResult" pInputText class="form-control" placeholder="e.g. 94%" />
                  </div>

                  <div class="form-group">
                    <label for="classXII">Class XII result</label>
                    <input id="classXII" formControlName="ClassXIIResult" pInputText class="form-control" placeholder="e.g. 96%" />
                  </div>
                </div>

                <!-- Undergraduate Details -->
                <div class="section-header">UNDERGRADUATE DETAILS</div>
                <div class="form-grid grid-3">
                  <div class="form-group">
                    <label for="universityName" class="required">University Name</label>
                    <input id="universityName" formControlName="UniversityName" pInputText class="form-control"
                      [class.invalid]="submitted && f['UniversityName'].invalid" placeholder="e.g. National Univ" />
                    <ng-container *ngIf="submitted && f['UniversityName'].invalid">
                      <div class="field-error" *ngIf="f['UniversityName'].errors?.['required']">University name is
                        required.</div>
                      <div class="field-error" *ngIf="f['UniversityName'].errors?.['pattern']">Only letters and common
                        characters allowed.</div>
                    </ng-container>
                  </div>

                  <div class="form-group">
                    <label for="universityCountry" class="required">Country</label>
                    <input id="universityCountry" formControlName="UniversityCountry" pInputText class="form-control"
                      [class.invalid]="submitted && f['UniversityCountry'].invalid" placeholder="e.g. United States" />
                    <ng-container *ngIf="submitted && f['UniversityCountry'].invalid">
                      <div class="field-error" *ngIf="f['UniversityCountry'].errors?.['required']">Country is required.
                      </div>
                      <div class="field-error" *ngIf="f['UniversityCountry'].errors?.['pattern']">Only letters allowed.
                      </div>
                    </ng-container>
                  </div>

                  <div class="form-group">
                    <label for="universityCity" class="required">City</label>
                    <input id="universityCity" formControlName="UniversityCity" pInputText class="form-control"
                      [class.invalid]="submitted && f['UniversityCity'].invalid" placeholder="e.g. Boston" />
                    <ng-container *ngIf="submitted && f['UniversityCity'].invalid">
                      <div class="field-error" *ngIf="f['UniversityCity'].errors?.['required']">City is required.</div>
                      <div class="field-error" *ngIf="f['UniversityCity'].errors?.['pattern']">Only letters allowed.
                      </div>
                    </ng-container>
                  </div>

                  <div class="form-group">
                    <label for="graduationYear" class="required">Graduation Year</label>
                    <input id="graduationYear" formControlName="GraduationYear" pInputText class="form-control"
                      [class.invalid]="submitted && f['GraduationYear'].invalid" placeholder="e.g. 2024" />
                    <ng-container *ngIf="submitted && f['GraduationYear'].invalid">
                      <div class="field-error" *ngIf="f['GraduationYear'].errors?.['required']">Graduation year is
                        required.</div>
                      <div class="field-error" *ngIf="f['GraduationYear'].errors?.['pattern']">Enter a valid year.</div>
                    </ng-container>
                  </div>

                  <div class="form-group">
                    <label for="degreeSubject" class="required">Degree Subject</label>
                    <input id="degreeSubject" formControlName="DegreeSubject" pInputText class="form-control"
                      [class.invalid]="submitted && f['DegreeSubject'].invalid" placeholder="e.g. Computer Science" />
                    <div *ngIf="submitted && f['DegreeSubject'].invalid" class="field-error">Degree / subject is
                      required.</div>
                  </div>

                  <div class="form-group">
                    <label for="gradeAchieved">Grade Achieved</label>
                    <input id="gradeAchieved" formControlName="GradeAchieved" pInputText class="form-control" placeholder="e.g. 8.9 GPA" />
                  </div>
                </div>

                <!-- Postgraduate Details — shown only when isPostgraduate -->
                <div *ngIf="isPostgraduate">
                  <div class="section-header">POSTGRADUATE DETAILS</div>
                  <div class="form-grid grid-3">
                    <div class="form-group">
                      <label for="secondUniversityName" class="required">University Name</label>
                      <input id="secondUniversityName" formControlName="SecondUniversityName" pInputText
                        class="form-control" [class.invalid]="submitted && f['SecondUniversityName'].invalid"
                        placeholder="e.g. Harvard" />
                      <ng-container *ngIf="submitted && f['SecondUniversityName'].invalid">
                        <div class="field-error" *ngIf="f['SecondUniversityName'].errors?.['required']">University name
                          is required.</div>
                        <div class="field-error" *ngIf="f['SecondUniversityName'].errors?.['pattern']">Only letters and
                          common characters allowed.</div>
                      </ng-container>
                    </div>

                    <div class="form-group">
                      <label for="secondUniversityCountry" class="required">Country</label>
                      <input id="secondUniversityCountry" formControlName="SecondUniversityCountry" pInputText
                        class="form-control" [class.invalid]="submitted && f['SecondUniversityCountry'].invalid"
                        placeholder="e.g. United States" />
                      <ng-container *ngIf="submitted && f['SecondUniversityCountry'].invalid">
                        <div class="field-error" *ngIf="f['SecondUniversityCountry'].errors?.['required']">Country is
                          required.</div>
                        <div class="field-error" *ngIf="f['SecondUniversityCountry'].errors?.['pattern']">Only letters
                          allowed.</div>
                      </ng-container>
                    </div>

                    <div class="form-group">
                      <label for="secondUniversityCity" class="required">City</label>
                      <input id="secondUniversityCity" formControlName="SecondUniversityCity" pInputText
                        class="form-control" [class.invalid]="submitted && f['SecondUniversityCity'].invalid"
                        placeholder="e.g. Cambridge" />
                      <ng-container *ngIf="submitted && f['SecondUniversityCity'].invalid">
                        <div class="field-error" *ngIf="f['SecondUniversityCity'].errors?.['required']">City is
                          required.</div>
                        <div class="field-error" *ngIf="f['SecondUniversityCity'].errors?.['pattern']">Only letters
                          allowed.</div>
                      </ng-container>
                    </div>

                    <div class="form-group">
                      <label for="secondGraduationYear" class="required">Graduation Year</label>
                      <input id="secondGraduationYear" formControlName="SecondGraduationYear" pInputText
                        class="form-control" [class.invalid]="submitted && f['SecondGraduationYear'].invalid"
                        placeholder="e.g. 2025" />
                      <ng-container *ngIf="submitted && f['SecondGraduationYear'].invalid">
                        <div class="field-error" *ngIf="f['SecondGraduationYear'].errors?.['required']">Graduation year
                          is required.</div>
                        <div class="field-error" *ngIf="f['SecondGraduationYear'].errors?.['pattern']">Enter a valid
                          year.</div>
                      </ng-container>
                    </div>

                    <div class="form-group">
                      <label for="secondDegreeSubject" class="required">Degree Subject</label>
                      <input id="secondDegreeSubject" formControlName="SecondDegreeSubject" pInputText
                        class="form-control" [class.invalid]="submitted && f['SecondDegreeSubject'].invalid"
                        placeholder="e.g. Data Science" />
                      <ng-container *ngIf="submitted && f['SecondDegreeSubject'].invalid">
                        <div class="field-error" *ngIf="f['SecondDegreeSubject'].errors?.['required']">Degree / subject
                          is required.</div>
                        <div class="field-error" *ngIf="f['SecondDegreeSubject'].errors?.['pattern']">Only letters and
                          common characters allowed.</div>
                      </ng-container>
                    </div>

                    <div class="form-group">
                      <label for="secondGradeAchieved">Grade Achieved</label>
                      <input id="secondGradeAchieved" formControlName="SecondGradeAchieved" pInputText
                        class="form-control" placeholder="e.g. 3.9 GPA" />
                    </div>
                  </div>
                </div>

              </div>
              <!-- END STEP 2 -->

              <!-- ════════════════════════════════
                   STEP 3 — TEST SCORES
              ═════════════════════════════════ -->
              <div *ngSwitchCase="3">
                <div class="test-group">
                  <div class="test-group-header">
                    <h3>UNDERGRADUATE SCORES</h3>
                  </div>
                  <p class="test-group-note">SAT, ACT and AP are most relevant for students applying to US colleges. All
                    fields are optional.</p>

                  <div class="score-row">
                    <div class="form-group">
                      <label for="satOverall">SAT OVERALL</label>
                      <input id="satOverall" formControlName="SATOverall" pInputText class="form-control"
                        placeholder="e.g. 1520" />
                      <div *ngIf="f['SATOverall'].invalid && f['SATOverall'].touched" class="field-error">Enter a valid
                        number.</div>
                    </div>

                    <div class="form-group">
                      <label for="satEnglish">SAT ENGLISH (ERW)</label>
                      <input id="satEnglish" formControlName="SATEnglish" pInputText class="form-control"
                        placeholder="e.g. 750" />
                      <div *ngIf="f['SATEnglish'].invalid && f['SATEnglish'].touched" class="field-error">Enter a valid
                        number.</div>
                    </div>

                    <div class="form-group">
                      <label for="satMath">SAT MATH</label>
                      <input id="satMath" formControlName="SATMath" pInputText class="form-control"
                        placeholder="e.g. 770" />
                      <div *ngIf="f['SATMath'].invalid && f['SATMath'].touched" class="field-error">Enter a valid
                        number.</div>
                    </div>
                  </div>

                  <div class="score-row">
                    <div class="form-group">
                      <label for="actOverall">ACT OVERALL</label>
                      <input id="actOverall" formControlName="ACTOverall" pInputText class="form-control"
                        placeholder="e.g. 34" />
                      <div *ngIf="f['ACTOverall'].invalid && f['ACTOverall'].touched" class="field-error">Enter a valid
                        number.</div>
                    </div>

                    <div class="form-group">
                      <label for="ielts">IELTS</label>
                      <input id="ielts" formControlName="IELTS" pInputText class="form-control"
                        placeholder="e.g. 8.0" />
                      <div *ngIf="f['IELTS'].invalid && f['IELTS'].touched" class="field-error">Enter a valid number.
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="toefl">TOEFL</label>
                      <input id="toefl" formControlName="TOEFL" pInputText class="form-control"
                        placeholder="e.g. 115" />
                      <div *ngIf="f['TOEFL'].invalid && f['TOEFL'].touched" class="field-error">Enter a valid number.
                      </div>
                    </div>
                  </div>

                  <div class="form-group full-width">
                    <label for="apScores">AP SCORES</label>
                    <input id="apScores" formControlName="APScores" pInputText class="form-control"
                      placeholder="e.g. Calculus BC: 5, Economics: 5" />

                  </div>
                </div>

                <div class="test-group">
                  <div class="test-group-header">
                    <h3>POSTGRADUATE SCORES</h3>
                  </div>
                  <p class="test-group-note">GRE is most common for Master's applicants. GMAT is also accepted by many
                    programmes</p>

                  <div class="score-row">
                    <div class="form-group">
                      <label for="greOverall">GRE OVERALL</label>
                      <input id="greOverall" formControlName="GREOverall" pInputText class="form-control"
                        placeholder="e.g. 328" />
                      <div *ngIf="f['GREOverall'].invalid && f['GREOverall'].touched" class="field-error">Enter a valid
                        number.</div>
                    </div>

                    <div class="form-group">
                      <label for="greVerbal">GRE VERBAL</label>
                      <input id="greVerbal" formControlName="GREVerbal" pInputText class="form-control"
                        placeholder="e.g. 162" />
                      <div *ngIf="f['GREVerbal'].invalid && f['GREVerbal'].touched" class="field-error">Enter a valid
                        number.</div>
                    </div>

                    <div class="form-group">
                      <label for="greQuant">GRE QUANT</label>
                      <input id="greQuant" formControlName="GREQuant" pInputText class="form-control"
                        placeholder="e.g. 166" />
                      <div *ngIf="f['GREQuant'].invalid && f['GREQuant'].touched" class="field-error">Enter a valid
                        number.</div>
                    </div>
                  </div>

                  <div class="score-row">
                    <div class="form-group">
                      <label for="gmatOverall">GMAT OVERALL</label>
                      <input id="gmatOverall" formControlName="GMATOverall" pInputText class="form-control"
                        placeholder="e.g. 730" />
                      <div *ngIf="f['GMATOverall'].invalid && f['GMATOverall'].touched" class="field-error">Enter a
                        valid number.</div>
                    </div>

                    <div class="form-group">
                      <label for="gmatSubScores">GMAT SUB-SCORES</label>
                      <input id="gmatSubScores" formControlName="GMATSubScores" pInputText class="form-control"
                        placeholder="e.g. Q50 V40 IR7 AWA5" />
                    </div>

                    <div class="form-group">
                      <label for="workExpBeforeMBA">WORK EXP. BEFORE MBA</label>
                      <input id="workExpBeforeMBA" formControlName="WorkExpBeforeMBA" pInputText class="form-control"
                        placeholder="e.g. 4 years" />
                    </div>
                  </div>

                  <div class="score-row">
                    <div class="form-group">
                      <label for="graduateIELTS">IELTS</label>
                      <input id="graduateIELTS" formControlName="GraduateIELTS" pInputText class="form-control"
                        placeholder="e.g. 8.0" />
                      <div *ngIf="f['GraduateIELTS'].invalid && f['GraduateIELTS'].touched" class="field-error">Enter a
                        valid number.</div>
                    </div>

                    <div class="form-group">
                      <label for="graduateTOEFL">TOEFL</label>
                      <input id="graduateTOEFL" formControlName="GraduateTOEFL" pInputText class="form-control"
                        placeholder="e.g. 115" />
                      <div *ngIf="f['GraduateTOEFL'].invalid && f['GraduateTOEFL'].touched" class="field-error">Enter a
                        valid number.</div>
                    </div>

                    <div class="form-group">
                      <label for="undergradGpa">UNDERGRAD GPA / DEGREE CLASS</label>
                      <input id="undergradGpa" formControlName="UndergradGpaDegreeClass" pInputText class="form-control"
                        placeholder="e.g. 3.85 / First" />
                    </div>
                  </div>
                </div>
              </div>

              <!-- ════════════════════════════════
                   STEP 4 — EXPERIENCE
              ═════════════════════════════════ -->
              <div *ngSwitchCase="4">
                <div class="form-group full-width">
                  <label for="shortBio" class="required">Short bio</label>
                  <textarea id="shortBio" formControlName="ShortBio" pInputTextarea class="form-control" rows="5"
                    placeholder="Introduce yourself in a few sentences..."></textarea>
                  <div *ngIf="submitted && f['ShortBio'].invalid" class="field-error">A short bio is required (min 20
                    characters).</div>
                </div>

                <div class="section-subheader">CAREER AREAS YOU CAN SPEAK TO</div>


                <div class="career-checkbox-grid" formArrayName="CareerAreas">
                  <div class="checkbox-option" *ngFor="let option of careerAreasOptions; let idx = index">
                    <p-checkbox [formControlName]="idx" [inputId]="'careerArea_' + idx" [binary]="true">
                    </p-checkbox>
                    <label [for]="'careerArea_' + idx">{{ option.label }}</label>
                  </div>
                </div>
                <div *ngIf="submitted && selectedCareerAreas.length === 0" class="field-error" style="margin-top: 6px;">
                  Please select at least one career area.
                </div>

                <div class="section-subheader">WORK AND INTERNSHIP HISTORY</div>
                <p class="section-helper">Add the roles you would like to be known for. You can add more than two.</p>

                <div class="work-history-list" formArrayName="WorkHistory">
                  <div *ngFor="let workGroup of workHistory.controls; let i = index" [formGroupName]="i"
                    class="work-history-entry">
                    <div class="work-history-grid">
                      <div class="form-group">
                        <label [for]="'company_' + i">
                          COMPANY OR ORGANISATION
                        </label>
                        <input [id]="'company_' + i" formControlName="company" pInputText class="form-control"
                          [class.invalid]="submitted && workGroup.get('company')?.invalid"
                          placeholder="e.g. McKinsey & Co." />
                        <div *ngIf="submitted && workGroup.get('company')?.invalid" class="field-error">
                          <span *ngIf="workGroup.get('company')?.errors?.['required']">Company is required.</span>
                          <span *ngIf="workGroup.get('company')?.errors?.['maxlength']">Max 100 characters.</span>
                        </div>
                      </div>
                      <div class="form-group">
                        <label [for]="'role_' + i">
                          ROLE
                        </label>
                        <input [id]="'role_' + i" formControlName="role" pInputText class="form-control"
                          [class.invalid]="submitted && workGroup.get('role')?.invalid" placeholder="e.g. Associate" />
                        <div *ngIf="submitted && workGroup.get('role')?.invalid" class="field-error">
                          <span *ngIf="workGroup.get('role')?.errors?.['required']">Role is required.</span>
                          <span *ngIf="workGroup.get('role')?.errors?.['maxlength']">Max 100 characters.</span>
                        </div>
                      </div>
                      <!-- X button always visible, removes if more than 1 row -->
                      <button type="button" class="remove-work-btn" (click)="removeWorkHistory(i)"
                        *ngIf="workHistory.length > 1" title="Remove">
                        <i class="pi pi-times"></i>
                      </button>
                    </div>
                  </div>

                  <div class="add-role-container">
                    <button type="button" class="add-role-pill" (click)="addWorkHistory()">
                      <i class="pi pi-plus"></i>
                      Add another role
                    </button>
                  </div>
                </div>

                <div class="section-subheader">SCHOLARSHIPS &amp; AWARDS</div>
                <div class="form-group full-width">
                  <textarea id="awards" formControlName="ScholarshipsAwards" pInputTextarea class="form-control"
                    [class.invalid]="submitted && f['ScholarshipsAwards'].invalid" rows="3"
                    placeholder="e.g. Rhodes Scholar, Dean's List..."></textarea>
                  <div *ngIf="submitted && f['ScholarshipsAwards'].invalid" class="field-error">Max 500 characters.
                  </div>
                </div>

                <div class="section-subheader">EXTRACURRICULAR ACTIVITIES</div>
                <div class="form-group full-width">
                  <textarea id="extracurriculars" formControlName="Extracurriculars" pInputTextarea class="form-control"
                    [class.invalid]="submitted && f['Extracurriculars'].invalid" rows="3"
                    placeholder="e.g. President of Debate Society, Robotics Club..."></textarea>
                  <div *ngIf="submitted && f['Extracurriculars'].invalid" class="field-error">Max 500 characters.</div>
                </div>
              </div>

              <!-- ════════════════════════════════
                   STEP 5 — REVIEW & SUBMIT
              ═════════════════════════════════ -->
              <div *ngSwitchCase="5">
                <div class="review-summary-grid">
                  <div class="review-box">
                    <div class="review-box-header">
                      <span class="review-box-title">1 &middot; ABOUT YOU</span>
                      <button type="button" class="edit-btn" (click)="goToStep(1)">Edit</button>
                    </div>
                    <p>{{ signupForm.value.FirstName }} {{ signupForm.value.LastName }}</p>
                    <p>{{ signupForm.value.Email }}</p>
                    <p class="review-sub"><em>Graduate Student &middot; {{ signupForm.value.UniversityName || 'MIT' }}
                        &middot; {{ signupForm.value.DegreeSubject || 'Computer Science' }}</em></p>
                  </div>

                  <div class="review-box">
                    <div class="review-box-header">
                      <span class="review-box-title">2 &middot; EDUCATION</span>
                      <button type="button" class="edit-btn" (click)="goToStep(2)">Edit</button>
                    </div>
                    <p>MSc {{ signupForm.value.SecondDegreeSubject || signupForm.value.DegreeSubject }}, {{
                      signupForm.value.SecondUniversityName || signupForm.value.UniversityName }}</p>
                    <p>{{ signupForm.value.SecondUniversityCity || signupForm.value.UniversityCity }}, {{
                      signupForm.value.SecondUniversityCountry || signupForm.value.UniversityCountry }} - {{
                      signupForm.value.SecondGraduationYear || signupForm.value.GraduationYear }}</p>
                    <p class="review-sub"><em>{{ signupForm.value.SchoolBoard || 'IB' }} - {{
                        signupForm.value.ClassXIIResult || '42/45' }} &middot; {{ signupForm.value.SchoolName || 'Delhi
                        Public School' }}</em></p>
                  </div>

                  <div class="review-box">
                    <div class="review-box-header">
                      <span class="review-box-title">3 &middot; TEST SCORES</span>
                      <button type="button" class="edit-btn" (click)="goToStep(3)">Edit</button>
                    </div>
                    <p>SAT {{ signupForm.value.SATOverall }} &middot; ERW {{ signupForm.value.SATEnglish }} &middot;
                      Math {{ signupForm.value.SATMath }}</p>
                    <p>GRE {{ signupForm.value.GREOverall }} &middot; V {{ signupForm.value.GREVerbal }} &middot; Q {{
                      signupForm.value.GREQuant }}</p>
                    <p class="review-sub"><em>IELTS {{ signupForm.value.IELTS || signupForm.value.GraduateIELTS }}</em>
                    </p>
                  </div>

                  <div class="review-box">
                    <div class="review-box-header">
                      <span class="review-box-title">4 &middot; EXPERIENCE</span>
                      <button type="button" class="edit-btn" (click)="goToStep(4)">Edit</button>
                    </div>
                    <p>
                      <ng-container *ngFor="let opt of careerAreasOptions; let i = index">
                        <ng-container *ngIf="isCareerAreaChecked(i)">{{ opt.label }} &middot; </ng-container>
                      </ng-container>
                    </p>
                    <ng-container *ngFor="let work of signupForm.value.WorkHistory">
                      <p *ngIf="work.company || work.role">{{ work.company }} &mdash; {{ work.role }}</p>
                    </ng-container>
                    <p class="review-sub"><em>{{ signupForm.value.ShortBio || 'Goldman Sachs — Summer Analyst' }}</em>
                    </p>
                  </div>
                </div>

                <div class="terms-section">
                  <div class="terms-header">GRADPILOTS PEER PARTICIPATION TERMS</div>
                  <div class="terms-grid-expanded">
                    <div class="terms-card-expanded">
                      <h4>Commitment</h4>
                      <p>As a GradPilots peer you agree to be available for occasional calls with students applying to
                        universities, at times that suit you. The expected commitment is two to four calls per month.
                        You are not paid — you contribute your time and experience to help the next generation of
                        students.</p>
                    </div>
                    <div class="terms-card-expanded">
                      <h4>Data</h4>
                      <p>GradPilots stores your profile information securely and will not share it with third parties
                        without your consent. Your email and contact number are not shown publicly.</p>
                    </div>
                    <div class="terms-card-expanded">
                      <h4>Your profile</h4>
                      <p>The information you provide may be displayed on the GradPilots platform and shown to students
                        and families. You can update or remove your profile at any time by contacting GradPilots
                        directly.</p>
                    </div>
                    <div class="terms-card-expanded">
                      <h4>Withdrawal</h4>
                      <p>You can exit the programme at any time by emailing the GradPilots team. Your profile will be
                        removed within 7 days of your request.</p>
                    </div>
                    <div class="terms-card-expanded full-width">
                      <h4>Conduct</h4>
                      <p>You agree to engage with students honestly, respectfully and professionally. You will not use
                        the peer programme to promote external services, sell products, or solicit students for any
                        commercial purpose.</p>
                    </div>
                  </div>
                </div>

                <div class="terms-full terms-checkbox-container">
                  <div class="checkbox-option">
                    <p-checkbox inputId="agreeTerms" formControlName="AgreedToTerms" [binary]="true"></p-checkbox>
                    <label for="agreeTerms"><strong>I have read and agree to the GradPilots Peer Participation Terms
                        above.</strong></label>
                  </div>
                  <div *ngIf="submitted && f['AgreedToTerms'].invalid" class="field-error">You must agree to the terms
                    to continue.</div>
                </div>


              </div>

            </ng-container>
          </div>

          <!-- ═══════════════════════════════════
               FOOTER — nav buttons + progress
          ════════════════════════════════════ -->
          <div class="wizard-footer" [class.final-step-footer]="currentStep === stepTitles.length">
            <div class="footer-progress-info" *ngIf="currentStep < stepTitles.length">
              <div class="progress-dots">
                <div class="dot" *ngFor="let title of stepTitles; let idx = index"
                  [class.active]="currentStep === idx + 1"></div>
              </div>
              <div class="step-text">Step {{ currentStep }} of {{ stepTitles.length }}</div>
            </div>

            <div class="footer-buttons">
              <button pButton type="button" class="btn btn-secondary" (click)="prevStep()"
                [disabled]="currentStep === 1">
                <i class="pi pi-chevron-left"></i>
                Back
              </button>

              <button pButton type="button" class="btn btn-primary" *ngIf="currentStep < stepTitles.length"
                (click)="nextStep()">
                Save &amp; Continue
                <i class="pi pi-chevron-right"></i>
              </button>

              <button pButton type="submit" class="btn btn-primary" *ngIf="currentStep === stepTitles.length"
                [disabled]="isSubmitting">
                <i *ngIf="isSubmitting" class="pi pi-spin pi-spinner"></i>
                {{ isSubmitting ? 'Submitting...' : 'Submit my application' }}
                <i *ngIf="!isSubmitting" class="pi pi-arrow-right"></i>
              </button>
            </div>
          </div>

        </form>
      </div>
    </main>
  </div>

  <p-toast></p-toast>
</div>